import { render } from "./AccountPlanPickerButton.vue?vue&type=template&id=5f16a1e0&scoped=true"
import script from "./AccountPlanPickerButton.vue?vue&type=script&lang=js"
export * from "./AccountPlanPickerButton.vue?vue&type=script&lang=js"

import "./AccountPlanPickerButton.vue?vue&type=style&index=0&id=5f16a1e0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5f16a1e0"

export default script